import { combineReducers } from "redux";
import document from "../features/admin/document/document/Slice";

const masters = combineReducers({
  document: document,
});

export default masters;
